import React from "react";
import { observer } from "mobx-react";
import Tippy from "@tippyjs/react";

import { Container } from "./style";

type Props = {
  content?: string;
  className?: string;
  children: React.ReactElement;
  childrenWithEllipsis?: boolean;
  duration?: [number | null, number | null] | number;
  offset?: [number, number];
  theme?: string;
  placement?: any;
  shouldOpen?: boolean;
};

const Tooltip = observer((props: Props) => {
  const {
    children,
    className,
    content,
    childrenWithEllipsis,
    offset,
    duration = [300, 250],
    theme = "default",
    placement = "bottom-start",
    shouldOpen = true,
  } = props;

  if (!content) {
    return children;
  }

  return (
    <Container
      className={className}
      childrenWithEllipsis={!!childrenWithEllipsis}
    >
      {shouldOpen ? (
        <Tippy
          arrow={false}
          content={content}
          placement={placement}
          theme={theme}
          offset={offset}
          maxWidth={500}
          duration={duration}
        >
          {children}
        </Tippy>
      ) : (
        children
      )}
    </Container>
  );
});

export default Tooltip;
